import {LANGUAGE} from '@/common/utils/constants';

export const LABEL_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		tooltips: {
			en: 'English',
			de: 'Deutch',
			fr: 'French',
			it: 'Italian',
			ja: 'Japanese',
			es: 'Spanish'
		}
	},
	[LANGUAGE.de.short]: {
		tooltips: {
			en: 'Englisch',
			de: 'Deutsch',
			fr: 'Französisch',
			it: 'Italienisch',
			ja: 'Japanisch',
			es: 'Spanisch'
		}
	},
	[LANGUAGE.fr.short]: {
		tooltips: {
			en: 'Anglais',
			de: 'Allemand',
			fr: 'Français',
			it: 'Italien',
			ja: 'Japonais',
			es: 'Espagnol'
		}
	},
	[LANGUAGE.it.short]: {
		tooltips: {
			en: 'Inglese',
			de: 'Tedesco',
			fr: 'Francese',
			it: 'Italiano',
			ja: 'Giapponese',
			es: 'Spagnolo'
		}
	},
	[LANGUAGE.ja.short]: {
		tooltips: {
			en: '英語',
			de: 'ドイツ人',
			fr: 'フランス語',
			it: 'イタリアの',
			ja: '日本',
			es: 'スペイン語'
		}
	},
	[LANGUAGE.es.short]: {
		tooltips: {
			en: 'Inglés',
			de: 'Alemán',
			fr: 'Francés',
			it: 'Italiano',
			ja: 'Japonés',
			es: 'Español'
		}
	}
}
